import { APIClients } from '../../api-client';

/**
 * Returns an array of filenames for the JS files currently loaded
 */
export const getLocalJSFilenames = () => {
  return getJSFilenames(document);
};

/**
 * Returns an array of filenames for the JS files in the latest version of index.html
 */
export const getServerJSFilenames = async () => {
  const response = await APIClients.getAPIClient().makePublicRequest<string>({
    payload: {
      request: {
        baseURL: window.location.origin,
        method: 'GET',
        responseType: 'text',
        url: '/'
      }
    }
  });

  return getJSFilenames(new DOMParser().parseFromString(response.data, 'text/html'));
};

/**
 * Returns an array of filenames for the JS files in the given Document object
 */
export const getJSFilenames = (dom: Document) => {
  return [...dom.querySelectorAll('script')].map(script => script.getAttribute('src') || '').filter(src => !!src);
};
